<!-- <div class="cdiv"> -->
<div class="c">
    <div class="headerback">
        <!-- <button mat-icon-button aria-label="Example icon button with a vertical three dot icon" class="backbtn">
           <mat-icon>arrow_back</mat-icon>
         </button> -->

        <button mat-mini-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="backhome()">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>

    <img class="icon icon-user" src="assets/images/recycle.png">
    <div class="wrapper" style="direction: rtl;">
        <p class="title" style="justify-content: center;text-align: center;font-weight: bold;">{{publicservice.Texts.Texts['about-us1']}}
        </p>
        <div style="justify-content: right;">
            <p>شهروندان فرهیخته شهر زندگی، سلام</p>
            <p>به منظور حفظ سلامت انسان‌ها و محیط زيست، شهرداری شاهرود با همکاری شرکت فولاد پارس شاهوار و با بهره گیری
                از تجربیات گذشته و دانش روز دنیا اقدام به اجرای طرح تفکیك پسماند از مبداء تولید نموده است.</p>
            <p style="font-weight: bold;">اﻫﺪاف ﻃﺮح:</p>
            <p>1- ﻓﺮﻫﻨﮓ ﺳﺎزي و آﻣﻮزش ﺗﻔﮑﯿﮏ ﭘﺴﻤﺎﻧﺪ از ﻣﺒﺪاء ﺗﻮﻟﯿﺪ</p>
            <p>2- ﺣﻔﻆ ﺳﻠﺎﻣﺖ ﺷﻬﺮوﻧﺪان و ﻣﺤﯿﻂ زﯾﺴﺖ</p>
            <p>3- ﺻﺮﻓﻪﺟﻮﯾﯽ در ﻣﺼﺮف ﻣﻨﺎﺑﻊ ﻃﺒﯿﻌﯽ ﺑﺎ ﺑﺎزﮔﺸﺖ ﻣﻮاد ﻗﺎﺑﻞ اﺳﺘﻔﺎده ﺑﻪ ﭼﺮﺧﻪ ﺗﻮﻟﯿﺪ</p>
            <p>4- ﺑﻬﯿﻨﻪﺳﺎزي ﺷﯿﻮهﻫﺎي ﺟﻤﻊآوري و ﺣﻤﻞ ﭘﺴﻤﺎﻧﺪ و ﻧﻈﺎﻓﺖ ﺷﻬﺮي</p>
            <p>5- ﺻﺮﻓﻪﺟﻮﯾﯽ در ﻫﺰﯾﻨﻪﻫﺎي ﺟﻤﻊآوري و ﺣﻤﻞ ﭘﺴﻤﺎﻧﺪ</p>
            <p style="font-weight: bold;">ﺗﻌﺎرﯾﻒ:</p>
            <p>ﭘﺴﻤﺎﻧﺪ: ﮐﻠﯿﻪ ﻣﻮاد زاﯾﺪ ﺣﺎﺻﻞ از ﻓﻌﺎلیت‌های اﻧﺴﺎن و ﺣﯿﻮان ﮐﻪ ﻣﻌﻤﻮﻟﺎ ﺟﺎﻣﺪ ﺑﻮده و ﺑﻪ ﺷﮑﻞ ﻓﻌﻠﯽ، ﺑﺮاي ﺧﻮد ﺷﺨﺺ و
                اﻓﺮاد ﺗﻮﻟﯿﺪﮐﻨﻨﺪه، ﻗﺎﺑﻞ اﺳﺘﻔﺎده ﻧﺒﺎﺷﺪ.</p>
            <p>ﭘﺴﻤﺎﻧﺪﻫﺎي ﺧﯿﺲ (ﺗﺮ) ﯾﺎ آﻟﯽ: ﭘﺴﻤﺎﻧﺪ ﻣﻮاد ﻏﺬاﯾﯽ، ﭘﺴﻤﺎﻧﺪﻫﺎي ﺑﺎﻏﺒﺎﻧﯽ، ﭘﻮﺳﺖ ﻣﯿﻮه‌ﺟﺎت و ﺳﺒﺰﯾﺠﺎت و...</p>
            <p>ﭘﺴﻤﺎﻧﺪﻫﺎي ﺧﺸﮏ ﯾﺎ ﻏﯿﺮآﻟﯽ: ﻓﻠﺰات، ﮐﺎﻏﺬ، ﺷﯿﺸﻪ، ﭘﻠﺎﺳﺘﯿﮏ</p>
            <p>ﭘﺴﻤﺎﻧﺪﻫﺎي ﺧﻄﺮﻧﺎك: زﺑﺎﻟﻪ ﺻﻨﺎﯾﻊ ﻣﺨﺘﻠﻒ، ﺑﯿﻤﺎرﺳﺘﺎنﻫﺎ و زاﯾﺪات ﺧﺎﻧﮕﯽ ﻧﻈﯿﺮ ﺑﺎﻃﺮي، ﺗﯿﻎ، ﻟﺎﻣﭗ ﻓﻠﺌﻮرﺳﻨﺖ، ﻟﺎك، اﻟﮑﻞ
                و ...</p>
            <p style="font-weight: bold;">اﻫﻤﯿﺖ ﭘﺴﻤﺎﻧﺪﻫﺎي ﺗﺮ (ﺧﯿﺲ): </p>
            <p>ﭘﺴﻤﺎﻧﺪﻫﺎي ﺗﺮ ﺑﻪ دﻟﯿﻞ دارا ﺑﻮدن ﻣﻘﺪار زﯾﺎدي از ﻣﻮاد ﻏﺬاﯾﯽ و ﺗﺮﮐﯿﺒﺎت آﻟﯽ و ﻫﻤﭽﻨﯿﻦ درﺻﺪ زﯾﺎد رﻃﻮﺑﺖ در ﺧﻮد،
                ﺑﺎﻋﺚ آﺳﯿﺐ ﺑﻪ ﺳﻠﺎﻣﺖ اﻧﺴﺎﻧﻬﺎ و ﻣﺤﯿﻂ زﯾﺴﺖ ﻣﯽ ﮔﺮدﻧﺪ.</p>
            <p style="font-weight: bold;">لطفا ﺑﺎور ﮐﻨﯿﻢ ﮐﻪ: </p>
            <p>118 ﻧﻮع ﺑﯿﻤﺎري ﺧﻄﺮﻧﺎك از ﻃﺮﯾﻖ ﭘﺴﻤﺎﻧﺪ اﻧﺘﻘﺎل ﭘﯿﺪا ﻣﯽﮐﻨﺪ ﻣﺎﻧﻨﺪ: ﻃﺎﻋﻮن، ﺳﺎﻟﮏ، اﻧﻮاع ﻣﺴﻤﻮﻣﯿﺖ ﻫﺎي ﻏﺬاﯾﯽ، آﺑﻠﻪ،
                ﺗﺐ ﻣﺎﻟﺖ، ﮐﯿﺴﺖ ﻫﯿﺪاﺗﯿﮏ، ﺳﯿﺎه زﺧﻢ</p>
            <p style="font-weight: bold;">اﻫﻤﯿﺖ ﭘﺴﻤﺎﻧﺪﻫﺎي ﺧﺸﮏ:</p>
            <p>1- ارزش اﻗﺘﺼﺎدي و ﺗﻮﻟﯿﺪ درآﻣﺪ</p>
            <p>2- ﺣﻔﻆ ﻣﻨﺎﺑﻊ ﻃﺒﯿﻌﯽ از ﻃﺮﯾﻖ اﺳﺘﻔﺎده ﻣﺠﺪد</p>
            <p>3- ﺣﻔﻆ ﻣﺤﯿﻂ زﯾﺴﺖ</p>
            <p style="font-weight: bold;">ﺗﺸﺮﯾﺢ ﻃﺮح:</p>
            <p>در اين طرح، دو برنامه اجرايی برای شهروندان تدارك ديده شده است.</p>
            <p style="font-weight: bold;">برنامه اول: ايستگاه‌هاي بازيافت</p>
            <p>در اين برنامه، شهروندان، پسماندهای خشك خود را از ساير پسماندها جداسازی کرده و به ايستگاهای شش گانه
                بازيافت(مستقر در آدرسهای زير) تحويل داده و پول آن را دريافت می نمايند.</p>
            <p>آدرس ايستگاههای شش گانه:</p>
            <p>1- تقاطع خیابان 22 بهمن و شهربانی</p>
            <p>2- چهار راه مدرسه قلعه</p>
            <p>3- میدان ولايت</p>
            <p>4- میدان بسیج</p>
            <p>5- شهرك کوثر</p>
            <p>6- شهرك بهارستان</p>
            <p> ساعات کار ايستگاه: صبحها از 9 الی 13 -عصرها از 17 الی 21</p>
            <p style="font-weight: bold;">برنامه دوم: اسنپ زباله</p>
            <p>در اين برنامه، خانوارها اپلیکیشن اسنپ زباله (Wastenapp) را دانلود و بر روی گوشی خود نصب می‌کنند. سپس هر
                زمان که مقدار پسماند خشك آنها بیش از 2 کیلوگرم شد پیغام خود را در آن می گذارند تا نزديکترين مامور شرکت
                به درب منزل مراجعه کرده و اقدام به دريافت پسماندها و پرداخت وجه نمايد</p>
            <p>در اين اپلیکیشن، مطالب آموزشی متعددی در زمینه اهمیت بازيافت، نحوه جداسازی پسماندها و سرنوشت پسماندهای
                خريداری شده گنجانده شده است. همچنین در اين اپلیکیشن امکان واريز وجه به حساب فرد ديگر يا خريد شارژ و غیره
                نیز وجود دارد.</p>
            <p style="font-weight: bold;">نحوه مشارکت شهروندان</p>
            <p>شما شهروند گرامی برای مشارکت در اين طرح فقط کافیست پسماندهای خشك را از ساير پسماندها جداسازی نمايید. برای
                اين منظور می توانید پسماندهای خشك خود را در کیسه ای پلاستیکی ريخته و سپس آن را به يکی از دو صورت فوق به
                مامورين شرکت تحويل دهید و وجه آن را دريافت نمائید.</p>
            <p style="font-weight: bold;">نکات مهم:</p>
            <p>1- به منظور افزايش مشارکت شهروندان در تفکیك پسماند، هر ماه به تعدادی از افرادی که پسماندهای خود را به
                ايستگاه های بازيافت يا اسنپ زباله تحويل داده اند بر اساس قرعه کشی، جوايز نفیسی نظیر آی پد،PS5 و غیره
                اهداء خواهد شد.</p>
            <p>2- با توجه به اينکه قیمت خريد هر نوع پسماند خشك از پسماند ديگر متفاوت است لذا با جدا کردن انواع پسماندهای
                خشك و تحويل جداگانه آنها به مامورين شرکت می توانید درآمد بیشتری کسب نمائید. برای مثال قیمت خريد کاغذ با
                قیمت خريد ظروف پلاستیکی متفاوت است</p>
            <p>3- شهرداری شاهرود به منظور همراهی با شما شهروندان گرامی در اين طرح، بخشی از هزينه های تحصیل فرزندان
                کارگران بازيافت را تقبل نموده است.</p>

        </div>
    </div>

</div>
<!-- </div> -->